import(/* webpackMode: "eager" */ "/src/clients/web/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/src/clients/web/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/src/clients/web/public/images/navbar/logo_main-nav.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/src/app/v1/components/HashScrollHandler.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/src/app/v1/components/HeaderV1.tsx");
;
import(/* webpackMode: "eager" */ "/src/clients/web/src/components/new-footer/new-footer.module.scss");
;
import(/* webpackMode: "eager" */ "/src/clients/web/src/app/v1/v1.module.scss");
